/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-shadow */

/**
 * Carousel types to be used in the frontend
 */
export enum CarouselType {
  SMALL_CIRCLE,
  SQUARE_SMALL,
  SQUARE_LARGE,
  SQUARE_REGULAR,
  SQUARE_REGULAR_WITH_DESCRIPTION,
  ON_GOING,
}

/**
 * Carousel sizes coming form the backend
 */
export enum CarouselSize {
  SMALL = 'small',
  REGULAR = 'regular',
  LARGE = 'large',
}

/**
 * Carousel styles coming form the backend
 */
export enum CarouselStyle {
  ROUNDED = 'rounded',
  REGULAR = 'regular',
  ON_GOING = 'ongoing_airing',
}
